export const TERMS_OF_SERVICE_URL = 'https://www.wicketsoft.com/tou/';
export const PRIVACY_POLICY_URL = 'https://www.wicketsoft.com/privacy-policy/';
export const SUPPORT_EMAIL = 'support@wicket.com';
